import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldMessageChannel']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldMessageChannel'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldMessageChannel'])
    },
}